export const ID_GRAU_DOUTORADO = 28;
export const ID_GRAU_DOUTORADO_PROFISSIONAL = 31;
export const ID_GRAU_MESTRADO = 27;
export const ID_GRAU_MESTRADO_PROFISSIONAL = 30;

// Chaves de localStorage usadas pelos formulários de indicação de vagas.
export const CHAVE_ID_PROGRAMA_PDAI_VAGAS = 'idProgramaPdaiVagas';
export const CACHE_PREFIX_SCPPG = 'scppg_';

/**
 * Monta a chave do programa PDAI-VAGAS escopada pelo CPF do usuário logado.
 * Impede que um usuário leia o programa persistido por outro (bug de cache
 * cruzado ao trocar de usuário no mesmo navegador).
 */
export function chaveIdProgramaPdaiVagas(cpf: string | number | null | undefined): string {
    return `${CHAVE_ID_PROGRAMA_PDAI_VAGAS}_${cpf ?? ''}`;
}

/**
 * Remove todos os dados de indicação de vagas do localStorage (programa
 * persistido + caches SCPPG). Deve ser chamada ao trocar de usuário
 * (logout e simular/remover acesso). O `remover` recebe um prefixo e apaga
 * todas as chaves que começam com ele.
 */
export function limparCacheIndicacaoVagas(remover: (prefixo: string) => void): void {
    remover(CHAVE_ID_PROGRAMA_PDAI_VAGAS);
    remover(CACHE_PREFIX_SCPPG);
}

export interface SelecaoProgramaPdaiVagas {
    programa: any | null;
    algumReprovouPorPrincipal: boolean;
    algumReprovouPorMestradoOuDoutorado: boolean;
}

/**
 * Seleciona o primeiro programa elegível para o edital PDAI-VAGAS
 * (programa em rede precisa ter agrupador principal; precisa ter
 * curso de Doutorado ou Doutorado Profissional).
 *
 * Retorna também flags com o motivo da reprovação para permitir que
 * o consumidor exiba mensagens de erro específicas.
 */
export function selecionarProgramaPdaiVagas(programas: any[]): SelecaoProgramaPdaiVagas {
    let algumReprovouPorPrincipal = false;
    let algumReprovouPorMestradoOuDoutorado = false;

    const lista = Array.isArray(programas) ? programas : [];
    const programa = lista.find((p: any) => {
        if (p.emRede === true) {
            const agrupadores = Array.isArray(p.agrupadoresInstituicaoEnsino)
                ? p.agrupadoresInstituicaoEnsino
                : [];
            if (!agrupadores.some((a: any) => a.principal === true)) {
                algumReprovouPorPrincipal = true;
                return false;
            }
        }
        const cursos = Array.isArray(p.cursos) ? p.cursos : [];
        const temMestradoOuDoutorado = cursos.some((c: any) =>
            c.idGrauAcademico === ID_GRAU_DOUTORADO ||
            c.idGrauAcademico === ID_GRAU_DOUTORADO_PROFISSIONAL ||
            c.idGrauAcademico === ID_GRAU_MESTRADO ||
            c.idGrauAcademico === ID_GRAU_MESTRADO_PROFISSIONAL
        );
        if (!temMestradoOuDoutorado) {
            algumReprovouPorMestradoOuDoutorado = true;
            return false;
        }
        return true;
    }) || null;

    return { programa, algumReprovouPorPrincipal, algumReprovouPorMestradoOuDoutorado };
}
